module.exports = __webpack_public_path__ + "img/yii.e135fb00.svg";